import './styles.scss'

import clsx from 'clsx'
import Skeleton from 'react-loading-skeleton'

import A11yButton from '@/components/A11yButton'
import ImageWithFallBack from '@/components/ImageWithFallback'

const SuggestionItem = ({
  isTransparent = false,
  isLoading = false,
  materialNumber = '',
  name = '',
  imageUrl = '',
  isIpadLandScape = false,
}) => (
  <A11yButton
    elementType="div"
    className={clsx(
      'suggestion-item__wrapper',
      isLoading && 'suggestion-item--loading',
    )}
    onKeyDown={(e) => e.preventDefault()}
  >
    {!isIpadLandScape && (
      <div className="suggestion-item__left">
        {isTransparent
          ? <div className="suggestion-item__image" />
          : isLoading
          ? <Skeleton height={60} width={60} />
          : (
            <ImageWithFallBack
              alt={name}
              className="suggestion-item__image"
              src={imageUrl}
            />
          )}
      </div>
    )}
    <div className="suggestion-item__right">
      {!isIpadLandScape && (
        <p className="suggestion-item__text suggestion-item__category">
          {isTransparent ? <>&nbsp;</> : isLoading ? <Skeleton /> : (
            materialNumber || 'N/A'
          )}
        </p>
      )}
      <p className="suggestion-item__text suggestion-item__name ">
        {isTransparent ? <>&nbsp;</> : isLoading ? <Skeleton /> : name || 'N/A'}
      </p>
    </div>
  </A11yButton>
)

export default SuggestionItem
